/**
 * REPORTS -- ENDPOINTS
 * @description
 * [ENDPOINTS] - This are the list of endpoints for the reports module
 */
// eslint-disable-next-line
export const REPORTS = {
  FIND: 'transactions/report' as 'bonus-engine/transactions/report',
  FIND_PROD:
    'game-transaction/v1/get-game-report' as 'game-transaction/v1/get-game-report',
  FIND_DEV:
    'game-transaction/v1/get-game-report' as 'game-transaction/v1/get-game-report',
}

// HERE
// export const REPORTS = {
//   FIND: 'bonus-engine/transactions/report' as 'bonus-engine/transactions/report',
//   FIND_PROD:
//     'gateway/game-transaction/getGameTransactionReport' as 'gateway/game-transaction/getGameTransactionReport',
//   FIND_DEV:
//     'crm/game-transaction/getGameTransactionReport' as 'crm/game-transaction/getGameTransactionReport',
// }
